import api from '../../utils/axios';

export const liveTrackingService = {
  getVouchers: async () => {
    const response = await api.get('/agent/vouchers');
    return response.data;
  },

  getVoucherById: async (voucherId) => {
    const response = await api.get(`/agent/vouchers/${voucherId}`);
    return response.data;
  },

  getGuests: async (voucherId) => {
    const response = await api.get(`/agent/vouchers/${voucherId}/guests`);
    return response.data;
  },

  pingGuest: async ({ bookingId, guestName = 'all', message }) => {
    const response = await api.post('/notifications/ping', {
      booking_id: bookingId,
      guest_name: guestName,
      message: message || 'Agent has requested for location. Please start sharing your live location.'
    });
    return response.data;
  }
};

export default liveTrackingService;
